$(document).ready(function() {
    // Initialize current reservations view


    // Period search functionality
    $('.period-input').on('change', function() {
        filterReservationsByPeriod();
    });

    // Sorting functionality
    $('.past-sort-select').on('change', function() {
        sortReservations($(this).val());
    });

    function filterReservationsByPeriod() {
        const fromDate = $('.period-input').first().val();
        const toDate = $('.period-input').last().val();
        
        if (!fromDate || !toDate) {
            $('.reservation-card.past').show();
            initPastReservationsView(); // Re-initialize view after showing all
            return;
        }
        
        const from = new Date(fromDate);
        const to = new Date(toDate);
        
        $('.reservation-card.past').each(function() {
            const dateText = $(this).find('.reservation-date').text();
            const reservationDate = parseReservationDate(dateText);
            
            if (reservationDate >= from && reservationDate <= to) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    }

    function sortReservations(sortBy) {
        const container = $('.past-reservations-list');
        const cards = container.find('.reservation-card.past').get();
        
        cards.sort(function(a, b) {
            if (sortBy === 'date') {
                const dateA = parseReservationDate($(a).find('.reservation-date').text());
                const dateB = parseReservationDate($(b).find('.reservation-date').text());
                return dateB - dateA; // Najnovšie najprv
            } else if (sortBy === 'venue') {
                const venueA = $(a).find('.reservation-date').text();
                const venueB = $(b).find('.reservation-date').text();
                return venueA.localeCompare(venueB);
            }
        });
        
        container.empty().append(cards);
        initPastReservationsView(); // Re-initialize view after sorting
    }

    function parseReservationDate(dateString) {
        // Parsovanie "Utorok 27.6.2025" na Date objekt
        const parts = dateString.split(' ');
        if (parts.length >= 2) {
            const datePart = parts[1]; // "27.6.2025"
            const dateComponents = datePart.split('.');
            if (dateComponents.length === 3) {
                const day = parseInt(dateComponents[0]);
                const month = parseInt(dateComponents[1]) - 1; // Mesiace sú 0-indexed
                const year = parseInt(dateComponents[2]);
                return new Date(year, month, day);
            }
        }
        return new Date();
    }

    // Cancel reservation button
    $(document).on('click','.js-storno-reservation-btn', function() {
        if (confirm('Naozaj chcete zrušiť túto rezerváciu?')) {

            let reservation_id = $(this).data('reservation-id');
            let is_calendar_page = $('.js-calendar-wrapper').length > 0 ? 1 : 0;

            if(is_calendar_page){
                $(this).closest('.reservation-card').fadeOut(function() {
                    $(this).remove();
                    let badge = $('#myReservationsBtn .badge');
                    let current_number_of_reservations = badge.text();
                    // minus 1
                    badge.text( parseInt(current_number_of_reservations) - 1 );
                });
            }

            let data_to_send = {
                action: 'storno_reservation',
                reservation_id: reservation_id,
                is_calendar_page: is_calendar_page
            }

            jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response){
                if(response){
                    response = JSON.parse( response );

                    if(response.success){

                        if(is_calendar_page){
                            notif('success', response.notif);
                            let term_type = $('.js-select-term.active').data('term');
                            let is_regular = term_type === 'regular' ? 1 : 0;

                            let week = 0;

                            if (!is_regular) {
                                week = get_get_param('week');
                            }
                            get_table_calendar_html(term_type, week);
                        }else{
                            location.reload();
                        }
                    }else{
                        notif(response.notif_type, response.notif);
                    }
                }
            })

        }
    });

    // Initialize reservations views on load
    //initCurrentReservationsView();
    //initPastReservationsView();

    $('.js-old-reservations-page').click(function(){
        $('.js-old-reservations-page.active').removeClass('active');
        old_reservations_pagination($(this).data('page'));
        $(this).addClass('active');
    })

    function old_reservations_pagination(page){


        let wrapper = $('.js-past-reservations-list');
        wrapper.addClass('loading');

        let data_to_send = {
            action: 'my_profile_old_reservations_content',
            page: page,
        };

        jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {
            if(response){
                //response = JSON.parse( response );

                if(response){
                    wrapper.html(response);
                    wrapper.removeClass('loading');
                }
            }
        });
    }
});
